export default __webpack_public_path__ + "static/char-s-07-cht-aa18f2f3383ad65ab63776cec9102564.png";